import { render } from "./MiezzPagination.vue?vue&type=template&id=188b13bb&scoped=true&ts=true"
import script from "./MiezzPagination.vue?vue&type=script&lang=ts"
export * from "./MiezzPagination.vue?vue&type=script&lang=ts"

import "./MiezzPagination.vue?vue&type=style&index=0&id=188b13bb&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188b13bb"]])

export default __exports__